import React, { Component } from 'react';
import { Api } from '../../../lib/api';

import {
    InputNumber,
    message,
    Input,
    Button,
    Modal,
} from 'antd';

class CreateConnectorModal extends Component {
    state = {
        il: this.props.il,
        rl: this.props.rl,
        name: this.props.name,
        connectors: this.props.connectors,
        selectedConnector: this.props.selectedConnector
    };

    close = () => {
       this.props.close();
    }

    render() {
        return(
            <Modal
                title="Create Connector"
                open={this.props.isOpen}
                onCancel={this.close}
                footer={
                    <div className="footer">
                        <div className="buttons">
                            <Button
                                type="primary"
                                onClick={() => {
                                    Api.createConnector({
                                        name: this.state.name,
                                        mapping: [{ il: this.state.il, rl: this.state.rl }]
                                    })
                                        .then((connector) => {
                                            message.success('Save successful', 3);
                                            this.setState({
                                                name: null,
                                                il: null,
                                                rl: null
                                            });
                                            this.props.updateConnectors(connector);
                                        })
                                        .catch(() => {
                                            message.error('Save failed');
                                        });
                                    this.close();
                                }}
                            >
                                Create
                            </Button>
                            <Button
                                onClick={() => {
                                    let connector = this.state.connectors.find(
                                        (connector) =>
                                            connector.id === this.state.selectedConnector
                                    );
                                    this.setState({
                                        name: null,
                                        il: connector ? connector.mapping.il : null,
                                        rl: connector ? connector.mapping.rl : null,
                                    });
                                    this.close();
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                }
            >
                <React.Fragment>
                    <div className="title">Connector Type:</div>

                    <Input
                        defaultValue={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        autoFocus
                    />

                    <React.Fragment key={this.state.tableIndex}>
                        <div className="connector-mapping-table">
                            <div>
                                <div className="title">IL &le;&nbsp;</div>
                                <InputNumber
                                    defaultValue={this.state.il}
                                    onChange={(value) => this.setState({ il: value })}
                                    formatter={(value) =>
                                        `${value.replace(/^[A-Za-z--]+$/, '')}`
                                    }
                                    min={0}
                                />
                            </div>
                            <div>
                                <div className="title">RL &ge;&nbsp;</div>
                                <InputNumber
                                    defaultValue={this.state.rl}
                                    onChange={(value) => this.setState({ rl: value })}
                                    formatter={(value) =>
                                        `${value.replace(/^[A-Za-z--]+$/, '')}`
                                    }
                                    min={10}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                </React.Fragment>
            </Modal>
        );
    }
}

export default CreateConnectorModal;